import axios, { AxiosError } from "axios";
const TenantResource = {
    get(tenantId, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/tenants/${tenantId}`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    search(searchParams, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/tenants`, {
            params: searchParams
        })
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
};
export default TenantResource;
